export const getColumnsHeaders = (intl) => ({
  fileName: { sortable: true },
  model: {
    //translatable: true,
    sortable: true,
    filterable: true,
    filterableDropdownWidth: 150,
    filterableData: {
      1: {
        value: 'delivery',
        label: intl.formatMessage({
          id: 'pages.quality.ocr.preProcessedDocuments.delivery',
        }),
      },
      2: {
        value: 'deliveryPC',
        label: intl.formatMessage({
          id: 'pages.quality.ocr.preProcessedDocuments.deliveryPC',
        }),
      },
      3: {
        value: 'laboratory',
        label: intl.formatMessage({
          id: 'pages.quality.ocr.preProcessedDocuments.laboratory',
        }),
      },
    },
  },
  createdAt: { sortable: true },
});
